import jQuery from 'jquery';

/** Lightbox anchor that may have Magnific Popup attached on the DOM node. */
type LightboxAnchorElement = HTMLElement & { magnificPopup?: unknown };

/** Selector for lightbox anchors inside Group Carousel infinite-scroll clone slides. */
export const GROUP_CAROUSEL_CLONE_LIGHTBOX_SELECTOR = '.et_pb_group_carousel_clone .et_pb_lightbox_image';

/** Window event fired after Group Carousel clones are created (frontend). */
export const GROUP_CAROUSEL_INIT_EVENT = 'divi:groupCarousel:init';

/**
 * Returns lightbox anchors that are not yet bound to Magnific Popup.
 */
export const filterUnboundLightboxAnchors = (
  $lightboxAnchors: JQuery<LightboxAnchorElement>,
): JQuery<LightboxAnchorElement> => {
  const unboundAnchors = $lightboxAnchors
    .toArray()
    .filter((anchor: LightboxAnchorElement) => !(jQuery(anchor).data('magnificPopup') || anchor.magnificPopup));

  return jQuery(unboundAnchors);
};

/**
 * Returns clone-slide lightbox anchors within a carousel root element.
 */
export const getCarouselCloneLightboxAnchors = (carouselRoot: HTMLElement): LightboxAnchorElement[] =>
  Array.from(carouselRoot.querySelectorAll<LightboxAnchorElement>(GROUP_CAROUSEL_CLONE_LIGHTBOX_SELECTOR));

/**
 * Re-binds image lightbox on clone anchors after Group Carousel init.
 */
export const bindCarouselCloneLightboxOnInit = (
  event: Event,
  initLightbox: ($lightboxAnchors: JQuery<LightboxAnchorElement>) => void,
): void => {
  const carouselRoot = (event as CustomEvent<{ instance?: { element?: HTMLElement } }>).detail?.instance?.element;

  if (!carouselRoot) {
    return;
  }

  const cloneLightboxAnchors = getCarouselCloneLightboxAnchors(carouselRoot);

  if (0 === cloneLightboxAnchors.length) {
    return;
  }

  const $unboundAnchors = filterUnboundLightboxAnchors(jQuery(cloneLightboxAnchors));

  if (0 === $unboundAnchors.length) {
    return;
  }

  initLightbox($unboundAnchors);
};
